import React, { useEffect, useRef } from "react";
import moment from "../../constants/holidays";

import { ContentCard } from "../../components/content_card/ContentCard.js";

import Arrow from "../../assets/back-arrow.svg";

import { useProcessStore, useAnimationStore } from "../../stores/generalStore";

export const StepFour = (props) => {
	// zustand stores slicing
	const currentStep = useProcessStore((state) => state.currentStep);
	const moveNextStep = useProcessStore((state) => state.nextStep);
	const movePrevStep = useProcessStore((state) => state.prevStep);

	const pickupDate = useProcessStore((state) => state.pickupDate);
	const setPickupDate = useProcessStore((state) => state.setPickupDate);

	const today = new Date();
	const dateOptions = [
		moment(today).businessAdd(1, "day").format("DD.MM.yyyy"),
		moment(today).businessAdd(2, "days").format("DD.MM.yyyy"),
		moment(today).businessAdd(3, "days").format("DD.MM.yyyy"),
		moment(today).businessAdd(4, "days").format("DD.MM.yyyy"),
		moment(today).businessAdd(5, "days").format("DD.MM.yyyy"),
	];

	// scene interaction methods
	const shouldAnimateInvalid = useAnimationStore((state) => state.shouldAnimateInvalid);
	const deactivateInvalidAnimation = useAnimationStore((state) => state.deactivateInvalidAnimation);
	const activateInvalidAnimation = useAnimationStore((state) => state.activateInvalidAnimation);

	const handleDateChange = (event) => {
		setPickupDate(event.target.value);
	};

	const validateAndMove = () => {
		let inputInvalid = false;

		if (pickupDate === "0") inputInvalid = true;

		if (inputInvalid) {
			activateInvalidAnimation();
		} else {
			deactivateInvalidAnimation();
			moveNextStep();
		}
	};

	let inputStyle;
	if (pickupDate === "0") {
		inputStyle = {
			backgroundColor: "#f2f2f2",
		};
		if (shouldAnimateInvalid) {
			inputStyle = {
				backgroundColor: "#ffa6a6",
			};
		}
	}

	const container_ref = useRef();
	useEffect(() => {
		container_ref.current.style.maxHeight = container_ref.current.scrollHeight + "px";
	}, [currentStep]);

	return (
		<ContentCard
			location={"return_step " + (currentStep === 3 ? "active" : "collapsed")}
			width="520"
		>
			<h2>Krok 4: Datum svozu</h2>

			<div
				className="step_container"
				ref={container_ref}
			>
				<div className="pickup_date">
					<p>
						Chci svoz
						<select
							value={dateOptions.includes(pickupDate) ? pickupDate : "0"}
							onChange={(e) => handleDateChange(e)}
							style={inputStyle}
						>
							<option
								value="0"
								disabled
							>
								Zvolte datum
							</option>
							{dateOptions.map((val, index) => {
								return (
									<option
										key={index}
										value={val}
									>
										{val}
									</option>
								);
							})}
						</select>
					</p>
				</div>

				<div className="control_buttons">
					<button
						className="prev_step step_move"
						onClick={() => movePrevStep()}
					>
						<img
							src={Arrow}
							alt="prev step"
						/>
						<p>Předchozí krok</p>
					</button>
					<button
						className="next_step step_move"
						onClick={() => validateAndMove()}
					>
						<p>Další krok</p>
						<img
							src={Arrow}
							alt="next step"
						/>
					</button>
				</div>
			</div>
		</ContentCard>
	);
};
